module.exports = __webpack_public_path__ + "static/media/iso9001_2015.6b0b2cb5.png";